import { I18nString } from '@lifk/types'

export const layerCategories: Record<string, I18nString> = {
  metric: { 'en-us': 'Metric', 'es-mx': 'Métrico' },
  feature: { 'en-us': 'Feature', 'es-mx': 'Característica' },
  boundary: { 'en-us': 'Boundary', 'es-mx': 'Límite' }
}
